var _taggedTemplateLiteral = require("C:/vagrant_tienda/apache/kinedu-educators-landing/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3;

module.exports = function (e) {
  var t = {};

  function o(i) {
    if (t[i]) return t[i].exports;
    var n = t[i] = {
      i: i,
      l: !1,
      exports: {}
    };
    return e[i].call(n.exports, n, n.exports, o), n.l = !0, n.exports;
  }

  return o.m = e, o.c = t, o.d = function (e, t, i) {
    o.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: i
    });
  }, o.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, o.t = function (e, t) {
    if (1 & t && (e = o(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var i = Object.create(null);
    if (o.r(i), Object.defineProperty(i, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var n in e) {
      o.d(i, n, function (t) {
        return e[t];
      }.bind(null, n));
    }
    return i;
  }, o.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return o.d(t, "a", t), t;
  }, o.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, o.p = "", o(o.s = 40);
}({
  1: function _(e, t) {
    e.exports = require("react");
  },
  2: function _(e, t) {
    e.exports = require("styled-components");
  },
  3: function _(e, t) {
    e.exports = require("../../styles");
  },
  40: function _(e, t, o) {
    "use strict";

    var i = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = i(o(1)),
        r = i(o(2)),
        a = o(3),
        l = a.colorPalettes.KineduPalette,
        u = r.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  top: 0px;\n  width: 100%;\n  max-width: 425px;\n  max-width: ", ";\n  margin: ", "px;\n  border-radius: 6px;\n  box-shadow: 0px 4px 30px -12px ", ";\n\n  color: #fff;\n  background-image: ", ";\n  background-size: cover;\n  background-position: ", ";\n\n  ", "\n  transition: all 0.4s ease-in-out;\n\n  cursor: pointer;\n  overflow: hidden;\n  user-select: none;\n\n  :hover {\n    top: -2px;\n    box-shadow: 0px 22px 80px -30px ", ";\n    :after {\n      animation: shine 1.5s ease 0s 1 normal none running;\n    }\n  }\n\n  ", " {\n    width: ", ";\n  }\n\n  &:after {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n\n    transition: all 0.5s ease-in-out;\n    background: linear-gradient(311deg, transparent 30%, rgb(255, 255, 255, 0.2), transparent 70%) 0% 0% / 300% 300%;\n\n    @keyframes shine {\n      0%  {background-position:0% 50%; opacity: 0;}\n      20% {opacity: 1;}\n      50% {background-position:100% 50%;}\n      70% {opacity: 0;}\n      100% {background-position:100% 50%; opacity: 0;}\n    }\n  }\n"])), function (_ref) {
      var e = _ref.maxWidth;
      return "number" == typeof e ? e + "px" : e;
    }, function (_ref2) {
      var e = _ref2.gap;
      return e;
    }, l.shadeDark, function (_ref3) {
      var e = _ref3.image;
      return e ? "url(".concat(e, ")") : "";
    }, function (_ref4) {
      var e = _ref4.bgPosition;
      return e;
    }, function (_ref5) {
      var e = _ref5.show;
      return a.globalStyles.fade(e, .4);
    }, l.shadeDark, a.breakPoints.tablet, function (_ref6) {
      var e = _ref6.width;
      return Number.isInteger(e) ? e + "px" : e;
    }),
        s = r.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  height: 0;\n  padding: 0;\n  padding-bottom: ", "%;\n\n  ", " {\n    padding-bottom: ", "%;\n  }\n"])), function (_ref7) {
      var e = _ref7.heightRatio;
      return e;
    }, a.breakPoints.tablet, function (_ref8) {
      var e = _ref8.mdHeightRatio;
      return e;
    }),
        d = r.default.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  position: absolute;\n  display: flex;\n  flex-direction: column;\n\n  width: 100%;\n  height: 100%;\n\n  ", ";\n"])), function (_ref9) {
      var e = _ref9.innerStyle;
      return e;
    }),
        p = function p(_ref10) {
      var _ref10$children = _ref10.children,
          e = _ref10$children === void 0 ? null : _ref10$children,
          _ref10$className = _ref10.className,
          t = _ref10$className === void 0 ? "" : _ref10$className,
          _ref10$image = _ref10.image,
          o = _ref10$image === void 0 ? "" : _ref10$image,
          i = _ref10.onClick,
          r = _ref10.style,
          a = _ref10.innerStyle,
          _ref10$width = _ref10.width,
          l = _ref10$width === void 0 ? 280 : _ref10$width,
          _ref10$maxWidth = _ref10.maxWidth,
          p = _ref10$maxWidth === void 0 ? 425 : _ref10$maxWidth,
          _ref10$heightRatio = _ref10.heightRatio,
          c = _ref10$heightRatio === void 0 ? 85 : _ref10$heightRatio,
          _ref10$mdHeightRatio = _ref10.mdHeightRatio,
          f = _ref10$mdHeightRatio === void 0 ? 85 : _ref10$mdHeightRatio,
          _ref10$bgPosition = _ref10.bgPosition,
          g = _ref10$bgPosition === void 0 ? "" : _ref10$bgPosition,
          _ref10$gap = _ref10.gap,
          h = _ref10$gap === void 0 ? 10 : _ref10$gap,
          b = _ref10.show;
      return n.default.createElement(u, {
        image: o,
        className: t,
        onClick: i,
        style: r,
        width: l,
        maxWidth: p,
        bgPosition: g,
        gap: h,
        show: b
      }, n.default.createElement(s, {
        heightRatio: c,
        mdHeightRatio: f
      }, n.default.createElement(d, {
        innerStyle: a
      }, e)));
    };

    p.defaultProps = {}, t.default = p;
  }
});